<mat-card class="filter settingHeader">
  <div class="name">
    Manage Automation Process Report
  </div>

  <div class="quickAction">
    <mat-form-field class="example-form-field" appearence="fill">
      <mat-label>Search Automation Process</mat-label>
      <input matInput type="text"  [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <!-- <div class="">         
      <button mat-flat-button color="primary" (click)="openAddTemplates(addAIDialog)"> Add Templates </button>
    </div> -->

  </div>
</mat-card>


<mat-card class="documents">
  <table class="mat-table" *ngIf="!ShowNoRecordFound">
    <thead>
      <tr class="mat-header-row">
        <th class="mat-header-cell">File Name</th>
        <th class="mat-header-cell">Folder Name</th>
        <th class="mat-header-cell">Attempts</th>
        <th class="mat-header-cell">Error</th>
        <th class="mat-header-cell">Status</th>
        <th class="mat-header-cell">Content Ready</th>
        <th class="mat-header-cell">Field Ready</th>
        <th class="mat-header-cell">Prompt Ready</th>
        <th class="mat-header-cell">Automation Template</th>
        <th class="mat-header-cell">Field Template</th>
        <th class="mat-header-cell">Question Template</th>
        <th class="mat-header-cell">From</th>
        <th class="mat-header-cell">Model</th>
        <th class="mat-header-cell">ReRun</th>
        <th class="mat-header-cell">Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let temp of aITemplateList" class="mat-row" >
        <td class="mat-cell" matTooltip="{{temp.fileName}}" matTooltipClass="tooltip"><p>{{ temp.fileName }}</p></td>
        <td class="mat-cell" matTooltip="{{temp.folderName}}" matTooltipClass="tooltip"><p>{{ temp.folderName }}</p></td>
        <td class="mat-cell" matTooltip="{{temp.attempts}}" matTooltipClass="tooltip"><p>{{ temp.attempts }}</p></td>
        <td  class="mat-cell" matTooltip="{{temp.error}}" matTooltipClass="tooltip">
          <p *ngIf="temp.error!=''" (click)="showAutomationError(temp)"> <mat-icon>error</mat-icon>
          </p>
        </td>

        <td class="mat-cell">
          <p *ngIf="temp.status==0">Open</p>
          <p *ngIf="temp.status==1">Inprogress</p>
          <p *ngIf="temp.status==2">Completed</p>          
        </td>
        <td class="mat-cell">
          <mat-icon class="processed" *ngIf="temp.isContentProcessed">check_circle</mat-icon>
        </td>
        <td class="mat-cell">
          <mat-icon class="processed" *ngIf="temp.isFieldProcessed">check_circle</mat-icon>
        </td>
        <td class="mat-cell">
          <mat-icon class="processed" *ngIf="temp.isPromptProcessed">check_circle</mat-icon>
        </td>
        <td  class="mat-cell" matTooltip="{{temp.name}}" matTooltipClass="tooltip"><p>{{ temp.name }}</p></td>
        <td class="mat-cell" matTooltip="{{temp.fieldTemplateName}}" matTooltipClass="tooltip"><p>{{ temp.fieldTemplateName }}</p></td>
        <td class="mat-cell" matTooltip="{{temp.promptTemplateName}}" matTooltipClass="tooltip"><p>{{ temp.promptTemplateName }}</p></td>
        <td class="mat-cell">
          <p *ngIf="temp.docFrom==1">Core</p>
          <p *ngIf="temp.docFrom==2">Contact</p>
          <p *ngIf="temp.docFrom==3">Company</p>
          <p *ngIf="temp.docFrom==4">My Drive</p>
        </td>
        <td class="mat-cell" matTooltip="{{temp.model}}" matTooltipClass="tooltip"><p>{{ temp.model }}</p></td>
        <td class="mat-cell">
          <mat-icon *ngIf="temp.status!=1" class="notProcessed" (click)="ReRunAutomationForAITool(temp)">restore_page</mat-icon>
          <mat-spinner *ngIf="temp.status==1" diameter="20"></mat-spinner>
        </td>
        <td class="mat-cell">
          <button mat-icon-button class="trash" (click)="deleteAIAutomationTemplate(temp)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
</mat-card>



<app-loader></app-loader>